import React from 'react'
import { Route } from 'react-router'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'

const ExpenseList = React.lazy(() => import('@/modules/expense/components/list/expense-list'))
const ExpenseEditPage = React.lazy(() => import('@/modules/expense/components/edit/expense-edit-page'))

const expenseRoutes = (
  <>
    <Route path='expense/*' element={<RedirectToPlural />} />
    <Route path='expenses' Component={ExpenseList} handle={{ title: 'Ausgaben', options: { noBackgroundColor: true } }} />
    <Route path='expenses/new/:type?/:relatedTypeId?' Component={ExpenseEditPage} />
    <Route path='expenses/edit/:id/:type?' Component={ExpenseEditPage} />
  </>
)

export default expenseRoutes
